import { render, staticRenderFns } from "./courseClassify.vue?vue&type=template&id=8abea516&scoped=true"
import script from "./courseClassify.vue?vue&type=script&lang=js"
export * from "./courseClassify.vue?vue&type=script&lang=js"
import style0 from "./courseClassify.vue?vue&type=style&index=0&id=8abea516&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8abea516",
  null
  
)

export default component.exports